module.exports = __webpack_public_path__ + "img/오사카먹방.256d9a5d.jpg";